if (!customElements.get('purchase-facilitators')) {
  class PurchaseFacilitators extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.purchase-facilitators__slide');
      if (this.slides.length <= 1) return;

      this.currentIndex = 0;
      this.isAnimating = false;
      this.inner = this.querySelector('.purchase-facilitators__inner');
      this.autoplaySpeed = (parseInt(this.inner.dataset.speed) || 5) * 1000;

      this.prevButton = this.querySelector('[name="previous"]');
      this.nextButton = this.querySelector('[name="next"]');

      this.prevButton.addEventListener('click', () => this.prev());
      this.nextButton.addEventListener('click', () => this.next());

      this.addEventListener('mouseover', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.play();
    }

    goTo(index, direction) {
      if (this.isAnimating) return;
      this.isAnimating = true;

      var currentSlide = this.slides[this.currentIndex];
      var nextIndex = (index + this.slides.length) % this.slides.length;
      var nextSlide = this.slides[nextIndex];
      var exitClass = direction === 'next' ? 'slide-exit-left' : 'slide-exit-right';
      var enterClass = direction === 'next' ? 'slide-from-right' : 'slide-from-left';

      // Position incoming slide off-screen without transition
      nextSlide.style.transition = 'none';
      nextSlide.classList.remove('slide-from-right', 'slide-from-left');
      nextSlide.classList.add(enterClass);
      nextSlide.classList.add('is-active');

      // Force reflow so the position is applied before transition starts
      nextSlide.offsetHeight;

      // Enable transitions and animate both slides
      nextSlide.style.transition = '';
      nextSlide.classList.remove(enterClass);
      currentSlide.classList.add('is-exiting', exitClass);
      currentSlide.classList.remove('is-active');

      var self = this;
      currentSlide.addEventListener('transitionend', function handler() {
        currentSlide.removeEventListener('transitionend', handler);
        currentSlide.classList.remove('is-exiting', exitClass);
        self.isAnimating = false;
      });

      this.currentIndex = nextIndex;
    }

    next() {
      this.goTo(this.currentIndex + 1, 'next');
    }

    prev() {
      this.goTo(this.currentIndex - 1, 'prev');
    }

    play() {
      this.pause();
      this.autoplay = setInterval(() => this.next(), this.autoplaySpeed);
    }

    pause() {
      clearInterval(this.autoplay);
    }
  }

  customElements.define('purchase-facilitators', PurchaseFacilitators);
}
